import React, { useState } from 'react';
import './EventsPage.css';
import useCalendarEvents from '../hooks/useCalendarEvents';
import { EventsGrid, AddToCalendarButton } from '../components/Sections';

const PAGE_SIZE = 9;

// Full list of upcoming events with client-side paging. Access (member/admin
// only) is enforced by ProtectedRoute; rendered inside the main shell.
export default function EventsPage() {
  const { events, status } = useCalendarEvents({ max: 250 });
  const [page, setPage] = useState(1);

  const pageCount = Math.max(1, Math.ceil(events.length / PAGE_SIZE));
  const current = Math.min(page, pageCount);
  const shown = events.slice((current - 1) * PAGE_SIZE, current * PAGE_SIZE);

  return (
    <div className="events-page">
      <div className="events-page-head">
        <h1>Upcoming Events</h1>
        <AddToCalendarButton />
      </div>

      <EventsGrid events={shown} status={status} />

      {pageCount > 1 && (
        <div className="events-pager">
          <button
            type="button"
            className="events-page-btn"
            disabled={current <= 1}
            onClick={() => setPage(current - 1)}
          >
            ← Prev
          </button>
          <span className="events-page-count">
            Page {current} of {pageCount}
          </span>
          <button
            type="button"
            className="events-page-btn"
            disabled={current >= pageCount}
            onClick={() => setPage(current + 1)}
          >
            Next →
          </button>
        </div>
      )}
    </div>
  );
}
